import {useSlugByUUID} from "../../features/stories/store";
import {buildInternalPath} from "../../helpers/URLHelpers";
import {compose} from "ramda";
import RouterLink from "./RouterLink";

const getLinkRedirectProps = props => {
  if (!props) return {};
  const {linktype, slug = "", url = "", anchor, target} = props;

  const isInternal = linktype === "story";
  let redirectAddress = isInternal ? slug : url;
  if (isInternal) redirectAddress = buildInternalPath(redirectAddress);
  if (linktype === "email") redirectAddress = `mailto:${redirectAddress}`;
  if (anchor) redirectAddress = `${redirectAddress}#${anchor}`;

  return {[isInternal ? "to" : "href"]: redirectAddress, target};
};

const useLinkSlugDecorator = linkObject => {
  if (!linkObject.id) return linkObject;
  const slug = useSlugByUUID(linkObject.id);

  return {
    ...linkObject,
    slug,
  };
};

const useLinkRedirectProps = compose(
  getLinkRedirectProps,
  useLinkSlugDecorator
);

const StoryblokLink = ({linkObject, children, ...restProps}) => {
  const redirectProps = useLinkRedirectProps(linkObject);

  return (
    <RouterLink {...redirectProps} {...restProps}>
      {children}
    </RouterLink>
  );
};

export default StoryblokLink;
